import { http } from '@/core/api/';
const apiUrl = 'api/dashboardpost';

export const getTypes = (payload) => {
  return http.get(`api/code/scheduleitemtypes`, {
    params: { ...payload },
  });
};

export const getApplications = (payload) => {
  return http.get(`api/code/applications`, {
    params: { ...payload },
  });
};

export const getAllPosts = (payload) => {
  return http.get(`${apiUrl}`, {
    params: { ...payload },
  });
};

export const save = (payload) => {
  return http.post(`${apiUrl}`, payload);
};

export const get = (id) => {
  return http.get(`${apiUrl}/${id}`);
};

export const getAuthenticationMechanismTypes = () => {
  return http.get(`${apiUrl}/workshop/authtypes`);
};

export const changePostStatus = (postId, newStatus) => {
  return http.patch(`${apiUrl}/changestatus/${postId}`, newStatus);
};

export const changePostPriority = (postId, newStatus) => {
  return http.patch(`${apiUrl}/priority/${postId}`, newStatus);
};

export const getItemAreaTypes = () => {
  return http.get(`${apiUrl}/areatypes`);
};

export const getItemCategoryTypes = () => {
  return http.get(`${apiUrl}/categorytypes`);
};

export const getItemTagTypes = () => {
  return http.get(`${apiUrl}/tagtypes`);
};

export const getEducationalMaterialCategories = () => {
  return http.get(`${apiUrl}/educationalmaterial/categories`);
};

export const getWorkshopStatuses = () => {
  return http.get(`${apiUrl}/workshop/statuses`);
};

export const getAllWorkshop = (params) => {
  return http.get(`${apiUrl}/workshop/search`, { params });
};

export const getWorkshopDetail = (workshopId) => {
  return http.get(`${apiUrl}/workshop/${workshopId}`);
};

export const getLatestParticipant = () => {
  return http.get(`${apiUrl}/workshop/participant/lastRegistered`);
};

export const addWorkshopParticipant = (payload) => {
  return http.post(`${apiUrl}/addparticipant`, payload);
};

export const updateParticipantWorkshopStatus = (payload) => {
  return http.patch(`${apiUrl}/update/participant`, payload);
};

export const getEvents = (params) => {
  return http.get(`${apiUrl}/events/search`, { params });
};

export const redeemWorkshop = (payload) => {
  return http.post(`${apiUrl}/workshop/redeem`, payload);
};

export const getNews = () => {
  return http.get(`${apiUrl}/news`);
};

export const cardsbymodule = (moduleId, applicationId = null) => {
  return http.get(
    `${apiUrl}/cardsbymodule?moduleId=${moduleId}&applicationId=${applicationId}`
  );
};

export const getCalendarCategories = () => {
  return http.get(`${apiUrl}/calendarcategories`);
};

export const getWorkshopMethodologyTypes = () => {
  return http.get(`${apiUrl}/methodology/types`);
};

export const getAllWorkshopParticipants = (params) => {
  return http.get(`${apiUrl}/workshop/participants/search`, { params });
};
export const getVideos = (payload) => {
  return http.get(`${apiUrl}/videos`, {
    params: { ...payload },
  });
};

export const getGuides = (payload) => {
  return http.get(`${apiUrl}/userguides`, {
    params: { ...payload },
  });
};

export const notifyWorkshopParticipantAbsence = (payload) =>
  http.post(`${apiUrl}/workshop/participants/notifyabsence`, payload);

export const getWorkshopParticipantLogs = (params) => {
  return http.get(`${apiUrl}/participantlog`, { params });
};

export const validateWorkshopTests = (id) => {
  return http.get(`${apiUrl}/workshop/validatetests?dashboardpostid=${id}`);
};

export const retakeWorkshopExam = (id) => {
  return http.get(`${apiUrl}/workshop/retakeExam/${id}`);
};

export const saveQuestionnaireConfig = (payload) => {
  return http.post(`${apiUrl}/save/questionnaire`, payload);
};

export const getWorkshopTests = (payload) => {
  return http.get(`${apiUrl}/tests`, {
    params: { ...payload },
  });
};

export const removeQuestionnaire = (payload) => {
  return http.put(`${apiUrl}/remove/questionnaire`, payload);
};

export const getQuestionnaire = (id) => {
  return http.get(`${apiUrl}/questionnaireType/${id}`);
};

export const getQuestionnaireQuestionTypes = () =>
  http.get(`${apiUrl}/questionnaire/questions/types`);

export const getReportTypes = () => {
  return http.get(`${apiUrl}/graphic/reportTypes`);
};

export const getGraphicTypes = () => {
  return http.get(`${apiUrl}/graphicTypes`);
};

export const reorganize = (payload) =>
  http.post(`${apiUrl}/reorganize`, payload);

export const searchReorganizations = (params) =>
  http.get(`${apiUrl}/reorganizations`, { params });

export const getReorganization = (id) =>
  http.get(`${apiUrl}/reorganizations/${id}`);

export const removeReorganization = (id) =>
  http.delete(`${apiUrl}/reorganizations/${id}`);

export const getDocument = (id) => {
  return http.get(`api/documents/${id}`);
};
